// extracted by mini-css-extract-plugin
export var alertBox = "main-module--alert-box--6IXym";
export var main = "main-module--main--3nCMe";
export var metamorphosis = "main-module--metamorphosis--JuO1Z";
export var paddingEqualToHeader = "main-module--padding-equal-to-header--JwFos";
export var paddingEqualToHeaderOnPhone = "main-module--padding-equal-to-header-on-phone--f6tzr";
export var transparent = "main-module--transparent--XxfRt";
export var wrapper = "main-module--wrapper--DDcvT";